export const FOLLOWUPLIST_LOADING = "FOLLOWUPLIST_LOADING";
export const FOLLOWUPLIST_RESET = "FOLLOWUPLIST_RESET";
export const GET_FOLLOWUPLIST = "GET_FOLLOWUPLIST";
export const GET_FOLLOWUPLIST_SUCCESS = "GET_FOLLOWUPLIST_SUCCESS";
export const GET_FOLLOWUPLIST_FAIL = "GET_FOLLOWUPLIST_FAIL";
export const DELETE_FOLLOWUPLIST = "DELETE_FOLLOWUPLIST"
export const DELETE_FOLLOWUPLIST_SUCCESS = "DELETE_FOLLOWUPLIST_SUCCESS"
export const DELETE_FOLLOWUPLIST_FAIL = "DELETE_FOLLOWUPLIST_FAIL"
export const UPDATE_FOLLOWUPLIST = "UPDATE_FOLLOWUPLIST"
export const UPDATE_FOLLOWUPLIST_SUCCESS = "UPDATE_FOLLOWUPLIST_SUCCESS"
export const UPDATE_FOLLOWUPLIST_FAIL = "UPDATE_FOLLOWUPLIST_FAIL"
export const ADD_NEW_FOLLOWUPLIST = "ADD_NEW_FOLLOWUPLIST"
export const ADD_FOLLOWUPLIST_SUCCESS = "ADD_FOLLOWUPLIST_SUCCESS"
export const ADD_FOLLOWUPLIST_FAIL = "ADD_FOLLOWUPLIST_FAIL"